import { render } from "./FiltersStatistics.vue?vue&type=template&id=4610f612&ts=true&lang=pug"
import script from "./FiltersStatistics.vue?vue&type=script&lang=ts"
export * from "./FiltersStatistics.vue?vue&type=script&lang=ts"

import exportComponent from "/var/lib/gitlab-runner/builds/Ysdfp3TDT/0/z2a/z-tracker-partners/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__